import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-download-app-dialog',
  templateUrl: './download-app-dialog.component.html',
  styleUrls: ['./download-app-dialog.component.css']
})
export class DownloadAppDialogComponent implements OnInit {
  countdown= 10;
  private timer: any;

  constructor(
    private dialogRef: MatDialogRef<DownloadAppDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.startCountDown();
  }

  startCountDown() {
    this.timer = setInterval(() => {
      this.countdown --;

      if (this.countdown === 0) {
        this.closeDialog();
      }
    }, 1000)
  }

  closeDialog () {
    clearInterval(this.timer);
    this.dialogRef.close();
    sessionStorage.setItem("hasSeenDownloadDialog", this.data.isMobile);

  }
   _googlePlay(): void {
    window.open("https://play.google.com/store/apps/details?id=com.angkor_pass.app", "_blank");
  }

  _appStore(): void {
    window.open("https://apps.apple.com/us/app/angkor-pass/id6698859997", "_blank");
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

}
